import type { PlanUsage, PlanLimits } from "../types";

export function hasReachedReviewLimit(
	usage: PlanUsage,
	limits: PlanLimits,
	type: "total" | "text" | "audio" | "video"
): boolean {
	const limitMap = {
		total: "max_total_reviews",
		text: "max_text_reviews",
		audio: "max_audio_reviews",
		video: "max_video_reviews",
	} as const;

	const usageMap = {
		total: "total_reviews",
		text: "text_reviews",
		audio: "audio_reviews",
		video: "video_reviews",
	} as const;

	const limitKey = limitMap[type];
	const usageKey = usageMap[type];
	const limit = limits[limitKey];
	const currentUsage = usage[usageKey];

	if (limit === undefined || limit === null) {
		return false;
	}

	return currentUsage >= limit;
}